export const createGameMuteSlice = ()=>(set, get)=>({
            gameMute: {
                mutedPlayers: [],
                isMuted: (playerName)=>{
                    const { mutedPlayers } = get().gameMute;
                    return mutedPlayers.includes(playerName);
                },
                toggleMuteForPlayer: (playerName)=>{
                    const { isMuted, mutePlayer, unmutePlayer } = get().gameMute;
                    const wasMuted = isMuted(playerName);
                    if (wasMuted) unmutePlayer(playerName);
                    else mutePlayer(playerName);
                    const isCurrentlyMuted = !wasMuted;
                    get().gameClientConfig.onToggleMutePlayer(playerName, isCurrentlyMuted);
                },
                mutePlayer: (playerName)=>{
                    const { mutedPlayers, isMuted } = get().gameMute;
                    if (isMuted(playerName)) return;
                    set((state)=>({
                            gameMute: {
                                ...state.gameMute,
                                mutedPlayers: [
                                    ...mutedPlayers,
                                    playerName
                                ]
                            }
                        }));
                },
                unmutePlayer: (playerName)=>{
                    const { mutedPlayers, isMuted } = get().gameMute;
                    if (!isMuted(playerName)) return;
                    set((state)=>({
                            gameMute: {
                                ...state.gameMute,
                                mutedPlayers: mutedPlayers.filter((name)=>name !== playerName)
                            }
                        }));
                }
            }
        });
